import LeafletMapView, { createColorIcon } from "../maps/LeafletMapView";

const MapView = ({ longitude, latitude, height = "300px", width = "100%" }) => {
  if (latitude == null || longitude == null) {
    return (
      <div
        style={{ height, width }}
        className="flex items-center justify-center bg-muted text-sm text-muted-foreground rounded-lg"
      >
        Location unavailable
      </div>
    );
  }

  return (
    <LeafletMapView
      center={{ lat: latitude, lng: longitude }}
      zoom={18}
      height={height}
      width={width}
      markers={[
        {
          id: "property",
          lat: latitude,
          lng: longitude,
          color: "#D4603A",
          icon: createColorIcon("#D4603A"),
        },
      ]}
    />
  );
};

export default MapView;
